import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';

const AdminRoute = ({ children }) => {
  const { t } = useTranslation(['common', 'auth']);
  const { user, loading } = useAuth();
  const location = useLocation();

  // 如果正在加载，显示加载状态
  if (loading) {
    return <div>{t('common:loading', { defaultValue: 'Loading...' })}</div>;
  }

  // 如果用户未登录，重定向到登录页面
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 如果用户不是管理员，重定向到首页或显示无权限页面
  if (!user.is_admin) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column'
      }}>
        <h2>{t('auth:access_denied', { defaultValue: 'Access Denied' })}</h2>
        <p>{t('auth:no_permission', { defaultValue: 'You do not have permission to access this page' })}</p>
        <button onClick={() => window.history.back()}>{t('common:actions.go_back', { defaultValue: 'Go Back' })}</button>
      </div>
    );
  }

  // 如果用户是管理员，显示子组件
  return children;
};

export default AdminRoute; 